<template>
    <Layout>
        <b-card v-if="Object.keys(ses).length !== 0">
            <div class="print-size">
                <div class="row">
                    <div class="col-md-12" style="margin-bottom: 20px;">
                        <div class="col-md-3 float-left">
                            <div class="user-img">
                                <img
                                    :src="ses.profile_picture ? ses.profile_picture.name : ''"
                                    height="160px"
                                    width="160px"
                                    @error="
                                        'asset/no-image-found.png'


                                    "
                                />
                            </div>
                        </div>
                        <div class="col-md-9 offset-md-1">
                            <h4 class="text-center text-bold" style="text-transform:uppercase"
                                >Padma Bridge Rail Link Project(PBRLP), Phase-II</h4
                            >
                            <h4 class="text-center text-bold" style="text-transform:uppercase"> (Bhanga - Jashore)</h4>
                            <h5 class="text-center bold">RESETTLEMENT UNIT</h5>
                            <h5 class="text-center text-bold" style="margin-top:0px">PAYMENT VOUCHER</h5>
                            <h6 class="text-center text-bold">{{
                                ses.ep_types[0].is_titled == 1 ? 'TITLED ' : 'NON-TITLED'
                            }}</h6>
                        </div>
                    </div>
                    <div class="col-md-12" style="margin-bottom: 20px;">
                        <button
                            v-if="individual_voucher.is_debited == 0"
                            :disabled="debitBtnDisable"
                            class="btn btn-success btn-sm customButton mr-1 buttonLoad"
                            title="Debit this voucher"
                            @click.prevent="debitVoucher(individual_voucher.id)"
                            >Debit this voucher <i v-if="debitBtnLoader" class="fa fa-spinner fa-spin"></i
                        ></button>
                        <button
                            v-if="individual_voucher.is_debited != 1"
                            :disabled="deleteBtnDisable"
                            class="btn btn-danger btn-sm customButton mr-1"
                            title="Delete"
                            @click.prevent="deleteVoucher(individual_voucher.id)"
                            >Delete <i v-if="deleteButtonLoader" class="fa fa-spinner fa-spin"></i
                        ></button>
                        <a
                            class="btn btn-info btn-sm customButton mr-1"
                            @click="printWindow()"
                            href="javascript:void(0);"
                            title="Print this page"
                            >Print this page</a
                        >
                        <a
                            class="btn btn-danger btn-sm customButton"
                            href="javascript:void(0);"
                            title="Print Cheque"
                            @click.prevent="chequePrint"
                            >Print Cheque</a
                        >
                    </div>
                </div>
                <div>
                    <table class="table borderNone table-centered" style="color: black">
                        <tbody>
                            <tr>
                                <td><strong>Voucher No. : </strong></td>
                                <td><strong>Cheque No. : </strong></td>
                                <td><strong>Bank : </strong> Bangladesh Krishi Bank</td>
                                <td><strong>Date : </strong></td>
                            </tr>
                            <tr>
                                <td><strong>Paid to : </strong> {{ ses.name }}</td>
                                <td><strong>Father/Husband Name : </strong> {{ ses.father_husband_name }}</td>
                                <td><strong>Mother's Name : </strong> {{ ses.mother_name }}</td>
                                <td
                                    ><strong>District : </strong>
                                    {{
                                        ses.present_address ? ses.present_address.district : ses.district.district_desc
                                    }}</td
                                >
                            </tr>
                            <tr>
                                <td><strong>Household ID : </strong> {{ ses.household_number }}</td>
                                <td
                                    ><strong>EP ID : </strong>
                                    {{ epIdWithPaymentStatus(ses.ep_id.ep_id, ses.ep_id.is_paid) }}</td
                                >
                                <td
                                    ><strong>A/C No. : </strong>
                                    {{ ses.ses_bank != null ? ses.ses_bank.account_no : 'N/A' }}</td
                                >
                                <td
                                    ><strong>Bank : </strong>
                                    {{ ses.ses_bank != null ? ses.ses_bank.bank.bank_desc : 'N/A' }}</td
                                >
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <!--          <h5 class="font-weight-bold">A. Acquired Land:</h5>-->
                    <!--          <table class="table table-centered table-bordered" style="color: black">-->
                    <!--            <thead>-->
                    <!--            <tr>-->
                    <!--              <th>SL No.</th>-->
                    <!--              <th>LA Case No.</th>-->
                    <!--              <th>Dag No.</th>-->
                    <!--              <th>Type of Land</th>-->
                    <!--              <th>Acquired Land (Decimal)</th>-->
                    <!--              <th>CCL (BDT)</th>-->
                    <!--              <th>Replacement Value (BDT)</th>-->
                    <!--              <th>AGL (BDT)</th>-->
                    <!--            </tr>-->
                    <!--            </thead>-->
                    <!--            <tbody v-if="payment_lands.length > 0">-->
                    <!--            <tr v-for="(payment_land, index) in payment_lands" :key="index">-->
                    <!--              <td>{{ index + 1 }}</td>-->
                    <!--              <td>{{ payment_land.land.ccl_land.ccl.la_case ? payment_land.land.ccl_land.ccl.la_case.la_case_desc : '' }}</td>-->
                    <!--              <td>{{ payment_land.land.plot_no }}</td>-->
                    <!--              <td>{{ payment_land.land_type ? payment_land.land_type.land_type_desc : '' }}</td>-->
                    <!--              <td>{{ payment_land.current_self_affected }}</td>-->
                    <!--              <td>{{ parseFloat(payment_land.current_ccl_amount).toFixed(2) }}</td>-->
                    <!--              <td>{{ parseFloat(payment_land.current_pvac_amount).toFixed(2) }}</td>-->
                    <!--              <td>{{ parseFloat(payment_land.current_agl).toFixed(2) }}</td>-->
                    <!--            </tr>-->
                    <!--            </tbody>-->
                    <!--            <tfoot v-if="payment_lands.length > 0">-->
                    <!--            <tr>-->
                    <!--              <td style="padding: 4px !important;" colspan="4"><span class="font-weight-bold float-right" style="font-size:15px;">Total</span></td>-->
                    <!--              <td class="font-weight-bold">{{ total_land_info.total_land }}</td>-->
                    <!--              <td class="font-weight-bold">{{ total_land_info.total_ccl }}</td>-->
                    <!--              <td class="font-weight-bold">{{ total_land_info.total_pvac_amount }}</td>-->
                    <!--              <td class="font-weight-bold">{{ total_land_info.total_AGL }}</td>-->
                    <!--            </tr>-->
                    <!--            </tfoot>-->
                    <!--          </table>-->
                </div>
                <div style="margin-top: 14px !important;">
                    <table class="table table-centered table-bordered" style="color: black">
                        <thead>
                            <tr>
                                <th style="min-width:38px">Sl No.</th>
                                <th>Entitlement</th>
                                <th style="min-width: 130px">Code</th>
                                <th style="min-width: 100px">Amount (TK.)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[1] }}</td>
                                <td>{{ individual_voucher.entitledDesc[1] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[1] }}</td>
                                <td>{{ individual_voucher.amount_AGL }}</td>
                            </tr>

                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[2] }}</td>
                                <td>{{ individual_voucher.entitledDesc[2] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[2] }}</td>
                                <td>{{ individual_voucher.amount_RRC }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[3] }}</td>
                                <td>{{ individual_voucher.entitledDesc[3] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[3] }}</td>
                                <td>{{ individual_voucher.amount_AGS }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[4] }}</td>
                                <td>{{ individual_voucher.entitledDesc[4] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[4] }}</td>
                                <td>{{ individual_voucher.amount_TG }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[5] }}</td>
                                <td>{{ individual_voucher.entitledDesc[5] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[5] }}</td>
                                <td>{{ individual_voucher.amount_RG }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[6] }}</td>
                                <td>{{ individual_voucher.entitledDesc[6] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[6] }}</td>
                                <td>{{ individual_voucher.amount_TG_PCR_CPR }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[7] }}</td>
                                <td>{{ individual_voucher.entitledDesc[7] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[7] }}</td>
                                <td>{{ individual_voucher.amount_DRG_PCR_CPR }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[8] }}</td>
                                <td>{{ individual_voucher.entitledDesc[8] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[8] }}</td>
                                <td>{{ individual_voucher.amount_AGT }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[9] }}</td>
                                <td>{{ individual_voucher.entitledDesc[9] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[9] }}</td>
                                <td>{{ individual_voucher.amount_CGVFT }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[10] }}</td>
                                <td>{{ individual_voucher.entitledDesc[10] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[10] }}</td>
                                <td>{{ individual_voucher.amount_CGSCFS }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[11] }}</td>
                                <td>{{ individual_voucher.entitledDesc[11] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[11] }}</td>
                                <td>{{ individual_voucher.amount_CGSLL }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[12] }}</td>
                                <td>{{ individual_voucher.entitledDesc[12] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[12] }}</td>
                                <td>{{ individual_voucher.amount_CGIDCIP }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[13] }}</td>
                                <td>{{ individual_voucher.entitledDesc[13] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[13] }}</td>
                                <td>{{ individual_voucher.amount_CGEE }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[14] }}</td>
                                <td>{{ individual_voucher.entitledDesc[14] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[14] }}</td>
                                <td>{{ individual_voucher.amount_RARO }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[15] }}</td>
                                <td>{{ individual_voucher.entitledDesc[15] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[15] }}</td>
                                <td>{{ individual_voucher.amount_RARI }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[16] }}</td>
                                <td>{{ individual_voucher.entitledDesc[16] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[16] }}</td>
                                <td>{{ individual_voucher.amount_MG }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[17] }}</td>
                                <td>{{ individual_voucher.entitledDesc[17] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[17] }}</td>
                                <td>{{ individual_voucher.amount_CGVMH }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[18] }}</td>
                                <td>{{ individual_voucher.entitledDesc[18] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[18] }}</td>
                                <td>{{ individual_voucher.amount_CGVFH }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[19] }}</td>
                                <td>{{ individual_voucher.entitledDesc[19] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[19] }}</td>
                                <td>{{ individual_voucher.amount_CGNUC }}</td>
                            </tr>

                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[20] }}</td>
                                <td>{{ individual_voucher.entitledDesc[20] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[20] }}</td>
                                <td>{{ individual_voucher.amount_CGLIP }}</td>
                            </tr>
                            <tr>
                                <td>{{ individual_voucher.entitledSlRoman[21] }}</td>
                                <td>{{ individual_voucher.entitledDesc[21] }}</td>
                                <td>{{ individual_voucher.entitledShortCode[21] }}</td>
                                <td>0.00</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td class="font-weight-bold text-right" style="padding: 4px !important;"
                                    >Total Amount:</td
                                >
                                <td></td>
                                <td style="padding: 4px !important;">
                                    {{ individual_voucher.total_amount }}
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td class="font-weight-bold text-right"
                                    >(-) IT {{ individual_voucher.it_percentage }}%
                                </td>
                                <td></td>
                                <td>{{ individual_voucher.it_percentage_amount }}</td>
                            </tr>

                            <tr>
                                <td></td>
                                <td class="font-weight-bold text-right">Net Amount:</td>
                                <td></td>
                                <td>
                                    <span class="font-weight-bold">{{ individual_voucher.net_payable_amount }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-borderless" style="margin-top: 5px !important; color: black">
                        <tbody>
                            <tr>
                                <td style="max-width:300px">
                                    <span class="font-weight-bold">Total Taka in Word: </span>
                                    <span>{{ individual_voucher.net_payable_amount_in_words }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-bordered mt-2" style="color: black">
                        <thead>
                            <tr>
                                <td><p></p><br /></td>
                                <td></td>
                                <td></td>
                                <td><br /><br /><br /><br /></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th style="width: 25%">Sig./LTI of EP</th>
                                <th style="width: 25%">Area Manager (DORP)</th>
                                <th style="width: 25%">Team Leader/Deputy Team Leader (DORP)</th>
                                <th style="width: 25%">Asst. LA & Res. Officer-CSC</th>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-bordered" style="color: black">
                        <thead>
                            <tr>
                                <td><p></p><br /></td>
                                <td></td>
                                <td></td>
                                <td><br /><br /><br /><br /></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th style="width: 25%">Divisional Accountant, PBRLP</th>
                                <th style="width: 25%">SSAE (Resettlement)</th>
                                <th style="width: 25%">AD (Resettlement), PBRLP</th>
                                <th style="width: 25%">DD (Resettlement), PBRLP</th>
                            </tr>
                        </tbody>
                    </table>
                    <!--          <barcode :value="ses.ep_id.ep_id" :options="options"></barcode>-->
                </div>
            </div>
        </b-card>
        <b-card v-if="Object.keys(ses).length !== 0" style="display: none">
            <div id="print">
                <div class="print-conteiner sheet">
                    <div class="pHead">
                        <div class="date-container" style="">
                            <span>
                                <span>{{ current_date[0] }}</span>
                            </span>
                            <span>
                                <span>{{ current_date[1] }}</span>
                            </span>
                            <span>
                                <span>{{ current_date[3] }}</span>
                            </span>
                            <span>
                                <span>{{ current_date[4] }}</span>
                            </span>
                            <span>
                                <span>{{ current_date[6] }}</span>
                            </span>
                            <span>
                                <span>{{ current_date[7] }}</span>
                            </span>
                            <span>
                                <span>{{ current_date[8] }}</span>
                            </span>
                            <span>
                                <span>{{ current_date[9] }}</span>
                            </span>
                        </div>
                    </div>
                    <div class="pable">
                        <p>A/C Payee</p>
                    </div>
                    <p class="payto">
                        <strong class="EPName"
                            >{{ ses.name }} ( EP ID: {{ ses.ep_id.ep_id }} & Acc. No.:
                            {{ ses.ses_bank != null ? ses.ses_bank.account_no : 'N/A' }} )
                        </strong>
                    </p>
                    <p class="sumTaka">
                        <strong class="textNumber">{{ inWordTaka }}</strong>
                    </p>
                    <span class="amount">
                        <span>{{ amount }}</span>
                    </span>
                    <div class="backSlip">
                        <div class="scontainer">
                            <div class="BSB">
                                <p>{{ ses.name }}</p>
                                <p>{{ amount }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-card>
    </Layout>
</template>

<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import Multiselect from 'vue-multiselect'
import substr_replace from '@views/asset/js/substr_replace'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import http from '@state/http'
import { ToWords } from 'to-words'
import { epIdWithPaymentStatus } from '@/src/utils/format-epid'

export default {
    page: {
        title: 'EP Voucher',
        meta: [{ name: 'description', content: appConfig.description }],
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: 'EP Voucher',
            items: [
                {
                    text: 'Dashboard',
                    href: '/',
                },
                {
                    text: 'EP Voucher',
                    active: true,
                },
            ],
            debitBtnLoader: false,
            deleteButtonLoader: false,
            ses: {},
            individual_voucher: {},
            payment_lands: [],
            total_land_info: {},
            amount: '',
            inWordTaka: '',
            current_date: '',
            debitBtnDisable: false,
            deleteBtnDisable: false,
            barcode_ep_id: '',
            options: {
                fontSize: 32,
                font: 'Courier',
                width: 2,
                height: 40,
                marginTop: 20,
                marginBottom: 20,
                format: 'MSI',
                displayValue: false,
            },
        }
    },

    mounted() {
        // let payment_voucher_id = this.$route.params.payment_voucher_id;
        this.getPaymentVoucher()
        this.checkCurrentDate()
    },
    methods: {
        epIdWithPaymentStatus: epIdWithPaymentStatus,
        epModify(ep_id) {
            var split_string = ep_id.toString()
            return substr_replace(split_string, '#', 5, 0)
        },
        getPaymentVoucher() {
            let payment_voucher_id = this.$route.params.payment_voucher_id
            http.get('api/voucher/individual/' + payment_voucher_id).then((response) => {
                if (!response.error) {
                    this.ses = response.data.ses
                    this.barcode_ep_id = response.data.ses.ep_id.ep_id
                    this.payment_lands = response.data.payment_lands
                    this.total_land_info = response.data.total_land_info
                    this.individual_voucher = response.data.individual_voucher
                    this.amount = parseFloat(response.data.individual_voucher.total_amount_without_tax).toFixed(2)
                    this.inWordTaka = response.data.individual_voucher.inWordTaka
                }
            })
        },
        debitVoucher(payment_voucher_id) {
            this.debitBtnLoader = true
            this.deleteBtnDisable = true
            http.get('api/voucher/individual/debit/' + payment_voucher_id).then((response) => {
                if (!response.error) {
                    this.debitBtnLoader = false
                    this.deleteBtnDisable = false
                    window.location.reload()
                    this.$bvToast.toast(response.data.message, {
                        title: 'Success',
                        autoHideDelay: 5000,
                        variant: 'success',
                    })
                }
            })
        },
        deleteVoucher(payment_voucher_id) {
            if (confirm('Do you really want to delete?')) {
                this.deleteButtonLoader = true
                this.debitBtnDisable = true
                http.get('api/voucher/individual/delete/' + payment_voucher_id).then((response) => {
                    if (!response.error) {
                        this.deleteButtonLoader = false
                        this.debitBtnDisable = false
                        this.$router.push('/voucher/ep_ec_voucher/list/' + response.data.district_id, () => {
                            this.$toasted.show(response.data.message, {
                                theme: 'toasted-primary',
                                position: 'top-right',
                                duration: 30000,
                                type: 'success',
                                action: {
                                    text: 'Cancel',
                                    onClick: (e, toastObject) => {
                                        toastObject.goAway(0)
                                    },
                                },
                            })
                        })
                    }
                })
            }
        },
        checkCurrentDate() {
            this.current_date = moment().format('DD-MM-YYYY')
        },
        chequePrint() {
            this.$validator.validate().then((valid) => {
                if (valid) {
                    // Get HTML to print from element
                    const prtHtml = document.getElementById('print').innerHTML

                    // Get all stylesheets HTML
                    let stylesHtml = ''
                    for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                        stylesHtml += node.outerHTML
                    }

                    // Open the print window
                    const WinPrint = window.open('', '', 'width=1000,height=600')

                    WinPrint.document.write(`<!DOCTYPE html>
                        <html>
                          <head>
                            ${stylesHtml}
                            <style>.sheet {margin: 0;overflow: hidden;position: relative;box-sizing: border-box;page-break-after: always;}body.cheque .sheet { width: 22.86cm; height: 7.62cm; margin:0px;} @media print {body.cheque { width: 22.86cm;}.date-container>span>span,.amount>span{border-width: 0px;}}</style>
                          </head>
                          <body style="background: #ffffff">
                            ${prtHtml}
                          </body>
                        </html>`)

                    WinPrint.document.close()
                    WinPrint.focus()
                    WinPrint.print()
                    // WinPrint.close();
                }
            })
        },
        hide() {
            setTimeout(() => {
                this.show = false
            }, 5000)
        },
        printWindow() {
            window.print()
        },
    },
    filters: {
        toWords: function(value) {
            const toWords = new ToWords({
                localeCode: 'en-IN',
                converterOptions: {
                    currency: false,
                    ignoreDecimal: false,
                    ignoreZeroCurrency: false,
                },
            })
            if (!value) return ''
            return toWords.convert(value, { currency: false })
        },
        capitalize: function(value) {
            if (!value) return ''
            return value.toUpperCase()
        },
    },
}
</script>

<style scoped>
.table th,
.table td {
    padding: 5px !important;
}

@page {
    margin: 5px 5px 0px 5px;
    size: auto;
}

@media print {
    .customButton {
        display: none;
    }

    body {
        width: 21cm;
        height: 29.7cm;
    }
}

.table {
    margin-bottom: 0px !important;
}

.borderNone {
    border: none !important;
}

.borderNone th,
.borderNone td {
    border-top: none !important;
}

.print-size {
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    /*display: inline;*/
    /*width: 27.8cm;*/
    /*height: 29.7cm;*/
    /*width: 27.8cm;*/
    /*height: 450px;*/
}

td strong {
    font-weight: bold !important;
}

/*for cheque print*/
.sumTaka.customModel {
    background: rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 9999;
    overflow-x: auto;
}

.CM-body {
    background: white;
    min-height: 10.16cm;
    height: auto;
    width: 9in;
    float: none;
    margin: auto;
    margin-top: auto;
    margin-top: 10%;
    padding-top: 0;
}

.print {
    position: absolute;
    bottom: 10px;
    right: 100px;
}

.print-conteiner {
    float: none;
    margin: 0px;
    width: 22.86cm;
    min-height: 8.89cm;
    height: auto;
    position: relative;
    background: white;
    overflow: hidden;
    box-sizing: border-box;
    page-break-after: always;
}

.date-container {
    display: inline-block;
    float: right;
    margin-top: 3px;
    padding-top: 48px;
    margin-right: 24px;
}

.date-container > span {
    display: block;
    width: 21px;
    float: left;
    text-align: right;
    padding: 0px 1px;
}

.date-container > span > span {
    outline: 0px;
    width: 100%;
    text-align: center;
    border: 0.1px solid;
    padding: 1px 4px;
    font-family: sans-serif;
    font-size: 100%;
    line-height: 1.15;
    margin: 0;
}

.print-conteiner > p.payto {
    padding-left: 43px;
}

.print-conteiner > p.sumTaka:first-letter {
    padding-left: 96px;
}

.print-conteiner > p {
    font-size: 12px;
    margin: 0px;
    text-align: justify;
}

.payto {
    position: absolute;
    top: 115px;
    left: 172px;
}

.sumTaka {
    position: absolute;
    top: 135px;
    left: 178px;
    width: 11cm;
    line-height: 3;
}

.amount {
    position: absolute;
    right: 0.5cm;
    top: 144px;
    width: 215px;
}

.amount > span {
    outline: 0px;
    width: 5.7cm;
    height: 1.3cm;
    font-size: 20px;
    border: 0.1px solid;
    text-align: left;
    padding-left: 20px;
    padding-top: 9px;
    padding-bottom: 9px;
    padding-right: 100px;
}

.backSlip {
    position: absolute;
    bottom: 1.8cm;
    left: 2.7cm;
    top: 102px;
}

.backSlip .BSB {
    transform: rotate(-90deg);
    position: absolute;
    top: -10px;
    bottom: -10px;
    width: 3.95cm;
    line-height: 1.5;
}

.scontainer {
    position: relative;
    height: 100%;
}

.backSlip .BSB > p {
    font-size: 10px;
    margin: 0px;
    padding-left: 38px !important;
    width: 200px;
}

.closebtn {
    position: absolute;
    right: 20px;
    bottom: 10px;
}

.pable > p {
    border-top: 2px solid;
    border-bottom: 2px solid;
    transform: rotate(-38deg);
    margin-top: -30px;
    width: 290px;
    margin-left: -69px;
    padding-left: 50px;
    font-size: 12px;
}

.pable {
    margin-left: 148px;
    font-weight: bold;
    color: blue;
    width: 230px;
    height: 193px;
    overflow: hidden;
}

.sheet {
    margin: 0;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    page-break-after: always;
    color: black;
}

body.cheque .sheet {
    width: 22.86cm;
    height: 7.62cm;
    margin: 0px;
}

@media print {
    .date-container > span > span,
    .amount > span {
        border-width: 0px;
    }
}

@page {
    margin: 0;
}

.sheet {
    margin: 0;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    page-break-after: always;
}
</style>
